<template>
    <loading-page :permanent="true" override-message="Sign-in in Progress" />
</template>

<script>
import mgr from '@/store/user-manager';
import LoadingPage from '@/components/shared/loading/loading-page';

export default {
    name: 'callback',

    components: {
        LoadingPage,
    },

    async mounted() {
        try {
            await mgr.signinRedirectCallback().then((user) => {
                window.history.replaceState({}, window.document.title, window.location.origin + window.location.pathname);

                window.location = user.state || '/editor';
            });
            // if (window.opener) {
            //     window.opener.updateUser();
            //     window.close();
            // }
        } catch {
            // login error thrown and redirect happens
            // on initial load this will always throw error because user is not authenticated
        }
    },
};
</script>
